// Define constants (consider moving credentials to env vars later)

import fetchProxy from './fetchProxy'

const TOKEN_URL = 'https://dev.sso.citigov.bigtree.com.ar/oauth/token'
const CLIENT_ID = '019528e8-be7f-7b28-bd35-5bf77b70e49a'
const CLIENT_SECRET = '8iw0mDK5kAuN23CFlk3hrij3s1TwvxJk'
const API_BASE_URL = 'https://dev.api.cuandollega.escobar.bigtree.com.ar/api/v1'

/**
 * Fetches an OAuth access token using client credentials grant type.
 * Uses browser's btoa() for base64 encoding.
 * @returns {Promise<string|undefined>} The access token or undefined if an error occurs.
 */
async function getAccessToken () {
  // Encode credentials for Basic Auth using browser's btoa()
  const credentials = btoa(`${CLIENT_ID}:${CLIENT_SECRET}`)
  const body = 'grant_type=client_credentials'

  try {
    const response = await fetch(TOKEN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${credentials}`
      },
      body
    })

    if (!response.ok) {
      let errorDetails = 'No details provided'
      try {
        // Try parsing the error response body as JSON
        const errorData = await response.json()
        errorDetails = JSON.stringify(errorData)
      } catch (parseError) {
        // If body isn't JSON or is empty, try reading as text
        errorDetails = await response.text()
      }
      console.error(`Error obtaining token: ${response.status} ${response.statusText}. Details: ${errorDetails}`)
      // Throw an error to indicate failure
      throw new Error(`HTTP error ${response.status}: ${errorDetails}`)
    }

    const data = await response.json()
    return data.access_token
  } catch (error) {
    // Log the specific error encountered during the fetch or processing
    console.error('Failed to obtain access token:', error.message)
    // Return undefined to signal failure to the caller
    return undefined
  }
}

/**
 * Fetches real-time arrivals for a specific bus stop from MiBus API.
 * @param {string|number} stopId - The ID of the bus stop to get arrivals for
 * @returns {Promise<Object|undefined>} The arrivals data or undefined if an error occurs
 */
export const getRealTimeArrivalsMiBus = async (stopId) => {
  const stopIdWithoutEscobar = stopId.replace('escobar_', '')
  try {
    // First get the access token
    const token = await getAccessToken()
    if (!token) {
      throw new Error('Failed to obtain access token')
    }

    const response = await fetchProxy({
      url: `${API_BASE_URL}/paradas/${stopIdWithoutEscobar}/arribos`,
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'X-CSRF-TOKEN': ''
      }
    })

    return response.result
  } catch (error) {
    console.error('Error fetching MiBus arrivals:', error.message)
    return undefined
  }
}
